// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_TestSendResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_TestSendResponse — result of POST /franchisor-channels/test-send.
 *
 * SUCCESS ONLY at the envelope level — the delivery OUTCOME lives inside
 * `delivered`/`detail`, exactly like FranchisorChannelAdapter::deliver()'s
 * own contract (never throws for ordinary failure). `channel_not_found` and
 * `provider_not_supported` are the only paths that leave via sendError().
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface FranchisorChannels_TestSendResponseDados {
delivered: boolean
detail: string
provider_message_id: string
}

export type FranchisorChannels_TestSendResponse = ApiResponse<FranchisorChannels_TestSendResponseDados>;

registerResponseContract('FranchisorChannels_TestSendResponse', {
  delivered:           { type: 'boolean', required: true },
  detail:              { type: 'string',  required: true },
  provider_message_id: { type: 'string',  required: false },
})
